import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/apikeys')({
  head: () => ({
    meta: [{ title: 'API keys | Tekst' }],
  }),
});
